import { render } from "./ProductosList.vue?vue&type=template&id=6abb25ec&scoped=true"
import script from "./ProductosList.vue?vue&type=script&lang=js"
export * from "./ProductosList.vue?vue&type=script&lang=js"

import "./ProductosList.vue?vue&type=style&index=0&id=6abb25ec&scoped=true&lang=scss"

import exportComponent from "C:\\laragon\\www\\fronted_sit_bolivia\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6abb25ec"]])

export default __exports__